// extracted by mini-css-extract-plugin
module.exports = {"Tagline":"HomeTagline_Tagline__39nY_","noOverlayEffect":"HomeTagline_noOverlayEffect__2wsUe","Clone":"HomeTagline_Clone__2g7MB","Container":"HomeTagline_Container__2z3Kl"};